/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Restart_TitleInputs */

const en_us2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to week 1?`)
};

const pt_br2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar à semana 1?`)
};

const es_419_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Volver a la semana 1?`)
};

const pt_pt2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar à semana 1?`)
};

const fr_fr2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revenir à la semaine 1 ?`)
};

const de_de2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu Woche 1?`)
};

const it_it2_plan_build_restart_title = /** @type {(inputs: Plan_Build_Restart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornare alla settimana 1?`)
};

/**
* | output |
* | --- |
* | "Back to week 1?" |
*
* @param {Plan_Build_Restart_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_restart_title = /** @type {((inputs?: Plan_Build_Restart_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Restart_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_restart_title(inputs)
	if (locale === "es-419") return es_419_plan_build_restart_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_restart_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_restart_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_restart_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_restart_title(inputs)
	return en_us2_plan_build_restart_title(inputs)
});
export { plan_build_restart_title as "plan-build.restart_title" }